/* eslint-disable max-len */
import React from 'react';
import { Switch } from 'react-router';
import { Config } from '@leverege/plugin';
import classnames from 'classnames';
import { Dialogs, PortalOverlay, Button, Pane, Breadcrumbs } from '@leverege/ui-elements';
import { Toolbar, createConnect, TitleBar } from '@leverege/ui-plugin';
import { Attributes } from '@leverege/ui-attributes';
import I18N from '@leverege/i18n';
import { ValuesCache } from '@leverege/value-cache';
import Blocker from "../../views/blocker/Blocker.js";
import { Routes } from "../../routes/index.js";
import { getQueryTrigger } from "../utils/QueryTriggers.js";
import S from './MobileItemScreen.css';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const {
  tIcon
} = I18N.ns('molten.screens.item.ItemScreen');
class ItemScreen extends React.Component {
  static CLIENT = 'ItemScreen';
  constructor(props) {
    super(props);
    this.state = {};
    this.trigger = getQueryTrigger({
      loadData: this.loadData,
      objectType: props.relationship?.objectType,
      path: props.relationship?.path,
      client: ItemScreen.CLIENT,
      relationship: props.relationship,
      caches: new ValuesCache()
    }, this.getContext());
  }
  getContext() {
    return {
      client: ItemScreen.CLIENT,
      clientProps: this.props,
      clientState: this.state,
      mobile: true,
      reloadData: this.loadData
    };
  }
  componentDidMount() {
    this.unmounted = false;
    this.trigger.init?.();
  }
  componentDidUpdate(prevProps) {
    const {
      resourceId: pResourceId,
      item: prevItem
    } = prevProps;
    const {
      resourceId,
      item
    } = this.props;
    if (resourceId != null && pResourceId !== resourceId) {
      this.loadData();
    }
    if (item !== prevItem) {
      this.setTitle();
    }
  }
  componentWillUnmount() {
    this.trigger.cleanup?.();
    this.unmounted = true;
  }
  loadData = async opts => {
    await this.trigger.preQuery?.();
    const {
      delegate,
      dispatch
    } = this.props;
    try {
      await dispatch(delegate.get(opts));
      if (this.unmounted !== true && !this.isInError) {
        await this.trigger.postQuery?.();
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
      if (this.unmounted !== true && !this.isInError) {
        await this.trigger.postQuery?.(err);
      }
      this.isInError = true;
    }
  };
  setTitle = evt => {
    if (evt) {
      this.setState({
        title: evt.data
      }, () => {
        const {
          setTitle
        } = this.props;
        setTitle?.({
          data: this.renderTitle()
        });
      });
    } else {
      const {
        setTitle
      } = this.props;
      setTitle?.({
        data: this.renderTitle()
      });
    }
  };
  setIcon = ({
    data
  }) => {
    this.setState({
      icon: data
    });
  };
  setActionsContext = evt => {
    const {
      setActionsContext
    } = this.props;
    if (setActionsContext) setActionsContext(evt);
  };
  setActionsMatchContext = evt => {
    const {
      setActionsMatchContext
    } = this.props;
    if (setActionsMatchContext) setActionsMatchContext(evt);
  };
  openNavActions = () => {
    const {
      relationship,
      item
    } = this.props;
    const itemMatchContext = {
      use: 'navBar',
      client: ItemScreen.CLIENT,
      objectType: relationship?.objectType,
      path: relationship?.path
    };
    const name = Attributes.get(relationship?.blueprint?.nameAttribute || 'name', relationship?.objectType, item) || relationship?.blueprint?.name;
    Dialogs.show({
      component: NavActions,
      props: {
        itemMatchContext,
        context: this.getContext(),
        name
      },
      id: 'mobileItemScreenNavActions'
    });
  };
  onBack = e => {
    const {
      dispatch,
      delegate
    } = this.props;
    dispatch(delegate.parent().goTo());
  };
  renderTitle = () => {
    const {
      title,
      icon
    } = this.state;
    const {
      embed
    } = this.props;
    // its a class?
    if (title?.prototype instanceof React.Component || title?.prototype instanceof React.PureComponent) {
      const Clazz = title;
      return /*#__PURE__*/_jsx(Clazz, {});
    }
    // its a function
    if (typeof title === 'function') {
      return title();
    }
    // its a react component or its invalid
    if (typeof title === 'object') {
      return title;
    }
    if (embed) {
      const crumbs = [{
        icon: tIcon('arrowLeftIcon', 'fa fa-arrow-left fa-fw'),
        iconOpts: {
          style: {
            paddingRight: '20px',
            paddingLeft: '8px'
          }
        }
      }, {
        name: /*#__PURE__*/_jsxs(Button, {
          className: S.growFromZero,
          variant: "mobileScreenTitle",
          onClick: this.openNavActions,
          icon: icon,
          children: [/*#__PURE__*/_jsx("span", {
            className: S.ellipsis,
            children: title
          }), /*#__PURE__*/_jsx("i", {
            className: "fa fa-angle-down fa-fw"
          })]
        })
      }];
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Breadcrumbs, {
          className: classnames(S.breadcrumbs, S.grow),
          variant: "mobileItemScreen",
          crumbs: crumbs,
          onClick: this.onBack
        }), /*#__PURE__*/_jsx(Toolbar, {
          variant: "actionBar",
          matchContext: {
            client: ItemScreen.CLIENT,
            use: 'navActions'
          },
          context: this.getContext()
        })]
      });
    }
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Button, {
        className: S.growFromZero,
        variant: "mobileScreenTitle",
        onClick: this.openNavActions,
        icon: icon,
        children: [/*#__PURE__*/_jsx("span", {
          className: S.ellipsis,
          children: title
        }), /*#__PURE__*/_jsx("i", {
          className: "fa fa-angle-down fa-fw"
        })]
      }), /*#__PURE__*/_jsx(Toolbar, {
        variant: "actionBar",
        matchContext: {
          client: ItemScreen.CLIENT,
          use: 'navActions'
        },
        context: this.getContext()
      })]
    });
  };
  render() {
    const {
      relationship
    } = this.props;
    const {
      path,
      objectType
    } = relationship;
    const matchContext = {
      client: ItemScreen.CLIENT,
      objectType,
      path
    };
    return /*#__PURE__*/_jsx(Blocker, {
      matchContext: matchContext,
      context: this.props,
      render: this.renderChildren
    });
  }
  renderChildren = () => {
    const client = ItemScreen.CLIENT;
    const {
      item,
      relationship: {
        path,
        objectType
      },
      delegate,
      nameAttr
    } = this.props;
    const {
      setTitle,
      setIcon,
      setActionsContext,
      setActionsMatchContext
    } = this;
    const ref = delegate.getInterfaceUrl();
    const routeMatch = {
      client,
      objectType,
      path
    };
    const routeKey = `item:${client}:${objectType}:${path}`;
    return /*#__PURE__*/_jsx(Switch, {
      children: Routes.getRoutesFor(routeKey, null, routeMatch, {
        setTitle,
        setIcon,
        setActionsContext,
        setActionsMatchContext,
        parentItem: {
          type: objectType,
          data: item,
          ref,
          id: delegate.id
        },
        nameAttr,
        reloadData: this.loadData
      }, Config.get(client, 'redirectUrl'))
    });
  };
}
const connect = createConnect(ItemScreen.CLIENT, (s, props) => {
  return {
    client: ItemScreen.CLIENT,
    objectType: props.relationship?.objectType,
    path: props.relationship?.path
  };
});
export default connect((state, props) => {
  // const item = DataSources.getData( )
  const {
    delegate
  } = props;
  return {
    item: delegate.getItem(state, true)
  };
})(ItemScreen);
function NavActions(props) {
  const {
    show,
    onClose,
    itemMatchContext,
    context,
    name
  } = props;
  return /*#__PURE__*/_jsx(PortalOverlay, {
    show: show,
    onClose: onClose,
    position: "full",
    animation: "slideFromBottom",
    children: /*#__PURE__*/_jsxs(Pane, {
      variant: "navSecondaryMobileContainer",
      children: [/*#__PURE__*/_jsx(TitleBar, {
        variant: "navSecondaryMobileTitle|navSecondaryMobile|mobileTitle",
        title: name
      }), /*#__PURE__*/_jsx(Toolbar, {
        vertical: true,
        variant: "navSecondaryMobile",
        matchContext: itemMatchContext,
        context: {
          ...context,
          onClose
        }
      })]
    })
  });
}